/*
 * Shade dropdown: forwards a row pick to the matching swatch input so the theme's <variant-picker> handles the change
 * (fetch, re-render, URL update) exactly as for a swatch tap. Delegated on document because the dropdowns are replaced
 * on every variant change.
 *
 * Most dropdowns use the theme's <x-popover>. An inline one (`data-shade-dropdown-toggle` on the trigger) controls a
 * plain panel instead: below 1000px the theme turns every popover into a body-level sheet, and the inline list has to
 * push the page down.
 */
(function () {
  if (window.__shadeDropdownInit) return;
  window.__shadeDropdownInit = true;

  function panelFor(trigger) {
    return document.getElementById(trigger.getAttribute('aria-controls'));
  }

  function rowsOf(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll('.shade-dropdown__row'));
  }

  function closePanel(trigger, restoreFocus) {
    var panel = panelFor(trigger);
    if (!panel || panel.hidden) return;

    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus) trigger.focus();
  }

  function openPanel(trigger) {
    var panel = panelFor(trigger);
    if (!panel) return;

    document.querySelectorAll('[data-shade-dropdown-toggle][aria-expanded="true"]').forEach(function (other) {
      if (other !== trigger) closePanel(other, false);
    });

    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');

    var target = panel.querySelector('.shade-dropdown__row[aria-selected="true"]') || rowsOf(panel)[0];
    if (target) target.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-shade-dropdown-toggle]');

    if (toggle) {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        closePanel(toggle, false);
      } else {
        openPanel(toggle);
      }
      return;
    }

    // A click anywhere outside an open inline dropdown closes it.
    document.querySelectorAll('[data-shade-dropdown-toggle][aria-expanded="true"]').forEach(function (trigger) {
      if (!trigger.closest('.shade-dropdown').contains(event.target)) closePanel(trigger, false);
    });

    var row = event.target.closest('[data-shade-dropdown-value]');
    if (!row) return;

    var popover = row.closest('x-popover');
    if (popover && typeof popover.hide === 'function') popover.hide();

    var panel = row.closest('.shade-dropdown__panel');
    if (panel) {
      var owner = document.querySelector('[aria-controls="' + CSS.escape(panel.id) + '"]');
      if (owner) closePanel(owner, false);
    }

    var input = document.querySelector(
      'input[data-option-position][form="' + CSS.escape(row.dataset.form) + '"][value="' + CSS.escape(row.dataset.shadeDropdownValue) + '"]'
    );

    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', function (event) {
    var panel = event.target.closest && event.target.closest('.shade-dropdown__panel');
    var trigger = panel
      ? document.querySelector('[aria-controls="' + CSS.escape(panel.id) + '"]')
      : event.target.closest && event.target.closest('[data-shade-dropdown-toggle][aria-expanded="true"]');

    if (!trigger) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closePanel(trigger, true);
      return;
    }

    if (!panel || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return;

    var rows = rowsOf(panel);
    var index = rows.indexOf(event.target.closest('.shade-dropdown__row'));
    var next = rows[Math.min(rows.length - 1, Math.max(0, index + (event.key === 'ArrowDown' ? 1 : -1)))];

    if (next) {
      event.preventDefault();
      next.focus();
    }
  });

  // The desktop sticky bar hides on scroll-up; an open popover inside it would stay focus-trapped but invisible.
  var ticking = false;

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        ticking = false;

        // Open popovers may be moved to <body> by the theme, so locate the bar through the trigger.
        document.querySelectorAll('.shade-dropdown__popover[open]').forEach(function (popover) {
          var trigger = document.querySelector('[aria-controls="' + CSS.escape(popover.id) + '"]');
          var bar = trigger && trigger.closest('.product-sticky-bar');
          if (bar && getComputedStyle(bar).visibility === 'hidden') popover.hide();
        });
      });
    },
    { passive: true }
  );
})();
